import AuthClient from '@/lib/auth-client';
var ResourcesOneappTrainingProfile = {
  get: function get() {
    return AuthClient.get('/oneapp/training/profile');
  }
};
export default ResourcesOneappTrainingProfile;